export default {
  name: "DmTools",
  components: {},
  data: function () {
    return {};
  },
  created() {},
  methods: {
    getErrorClass: function (item) {
      item.bInvalid = false;
      if (!item.finalReading)
        item.finalReading = 0;

      //console.log("=======================================")
      //console.log("item.isAllowDisconReconWithoutReading", item.isAllowDisconReconWithoutReading)
      //console.log("item.finalReading", item.finalReading)
      //console.log(" item.previousReading", item.previousReading)
      //console.log(" item.finalReadingClockOver", item.finalReadingClockOver)

      if (item.isAllowDisconReconWithoutReading != true)
        item.bInvalid = item.finalReading < item.previousReading && item.finalReadingClockOver != true;
      else
        item.bInvalid = item.finalReading < item.previousReading && item.finalReadingClockOver != true && item.finalReading != 0;

      return item.bInvalid ? "md-invalid margin-bottom-40" : "";
    },
  },
};
